import { ViewStyle } from 'react-native';
import { isMobile, isTablet } from 'react-device-detect';
import { BASE_SLIDER_GAP } from '@24i/nxg-core-utils/src/constants';
import { getFont, getBorderRadius } from '@24i/nxg-sdk-higgs';
import {
    getTelegramWebApp,
    getTelegramWebAppTopSafeAreaInset,
    calculateTelegramGap,
} from '@24i/nxg-sdk-higgs/src/utils';
import { Theme } from '@24i/nxg-sdk-photon';
import { SliderStyles } from './types';
import { Breakpoint } from '../../../utils/styles/constants';

const BannerCarousel = (theme: Theme): SliderStyles => {
    let showTelegramGap;
    if (getTelegramWebApp()) {
        if (isTablet) {
            showTelegramGap = 0;
        } else if (isMobile) {
            showTelegramGap = getTelegramWebAppTopSafeAreaInset();
        } else {
            showTelegramGap =
                calculateTelegramGap() +
                (getTelegramWebAppTopSafeAreaInset() === 0
                    ? BASE_SLIDER_GAP
                    : getTelegramWebAppTopSafeAreaInset());
        }
    } else {
        showTelegramGap = BASE_SLIDER_GAP;
    }
    return {
        item: {
            backgroundColor: 'transparent',
            alignSelf: 'stretch',
            width: '100%',
            height: '66%',
        },
        image: {
            width: '100%',
            height: '66%',
        },
        dynamicLandscapeImage: {
            // should match slideContainer width when slide becomes portrait
            '@media (max-width: 743px)': {
                display: 'none',
            },
            display: 'flex',
        },
        dynamicPosterImage: {
            '@media (max-width: 743px)': {
                display: 'flex',
            },
            display: 'none',
        },
        slideHolder: {
            width: '100%',
            alignSelf: 'center',
            marginTop: showTelegramGap,
        },
        slideContainer: {
            flex: 1,
            flexDirection: 'column-reverse',
            marginLeft: '1%',
            marginTop: 12,
            '@media (max-width: 743px)': {
                marginRight: 8,
                //  @ts-ignore
                transition: 'height 999s, max-height 999s',
            },
            '@media (min-width: 800px) and (max-width: 1200px)': {
                marginRight: 8,
            },
            '@media (min-width: 1201px) and (max-width: 1600px)': {
                marginRight: 10,
            },
            '@media (min-width: 1600px)': {
                marginLeft: 12,
                marginRight: 10,
            },
            transition: '0.1s ease-in',
            ':hover': {
                marginTop: getTelegramWebApp() ? '12' : 'calc(0.4%)',
                marginBottom: getTelegramWebApp() ? 'auto' : 'calc(0.4%)',
                transform: getTelegramWebApp() ? 'none' : 'scale(1.02)',
            },
        } as ViewStyle,
        imageStyleContainer: {
            position: 'relative',
            height: 456,
            [`@media (min-width: ${Breakpoint.XL}px) and (max-width: ${Breakpoint.XXL}px)`]: {
                height: 560,
            },
            [`@media (min-width: ${Breakpoint.XXL}px)`]: {
                height: 620,
            },
        },
        imageStyle: {
            flex: 1,
            backgroundColor: 'transparent',
            width: '100%',
            borderRadius: 6,
            ...getBorderRadius(theme.elements, 'headerTile-cornerRadius'),
            overflow: 'hidden',
            zIndex: 0,
        },
        itemText: {
            textAlign: 'left',
            ...getFont(theme, 'h2'),
            color: '#fff',
        },
        textHolder: {
            position: 'absolute',
            bottom: 40,
            left: 32,
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            zIndex: 2,
            [`@media (max-width: ${Breakpoint.XL}px)`]: {
                left: 20,
                bottom: 30,
            },
            [`@media (max-width: ${Breakpoint.MD}px)`]: {
                bottom: 20,
            },
        },
        buttonsHolder: {
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 17,
        },
        titleViewHolder: {
            width: '85%',
        },
        gradient: {
            position: 'absolute',
            zIndex: 1,
            //  @ts-ignore
            background: theme.color.gradient2.color,
        },
        primaryButtonContainerWithTitle: {
            height: 52,
            width: 'auto',
            paddingLeft: 20,
            paddingRight: 25,
        },
        additionalSubactionButtonContainerStyles: {
            width: 42,
            paddingLeft: 0,
            paddingRight: 0,
            '@media (max-width: 1200px)': {
                width: 40,
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
        assetLabelContainer: { alignSelf: 'flex-start' },
        itemContainer: {
            transition: '0.1s ease-in',
            ':hover': {
                marginTop: getTelegramWebApp() ? '12' : 'calc(-0.4%)',
                marginBottom: getTelegramWebApp() ? 'auto' : 'calc(0.4%)',
                transform: getTelegramWebApp() ? 'none' : 'scale(1.02)',
            },
        } as ViewStyle,
        geoBlockIconContainer: {
            position: 'absolute',
            top: 34,
            right: 34,
            backgroundColor: theme.color.labelSecondary,
            zIndex: 10,
            height: 'auto',
            width: 'auto',
            padding: 2,
            borderRadius: 2,
        },
    };
};
export default BannerCarousel;
